import { useEffect, useState } from "react";
import riderService from "src/services/riderService";
import "../completedRide/completedRide.css";
import { format } from 'date-fns';

export default function CompletedRide() {
    const [completedRides, setCompletedRides] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [riderName, setRiderName] = useState('');
    const [createdDate, setCreatedDate] = useState('');

    const [totalAmount, setTotalAmount] = useState();
    const [commissionAmount, setCommissionAmount] = useState();
    const [allRiders, setAllRiders] = useState([]);


    useEffect(() => {
        getAllRiders();
        setIsLoading(true);
        let query = '';
        if (riderName.trim() !== '' && createdDate.trim() !== '') {
            query = `rider_name=${riderName.trim()}&created_date=${createdDate.trim()}`;
        } else if (riderName.trim() !== '') {
            query = `rider_name=${riderName.trim()}`;
        } else if (createdDate.trim() !== '') {
            query = `created_date=${createdDate.trim()}`;
        }
        if (query) {
            riderService.getAllCompletedRidesWithFilter(query).then(
                (res) => {
                    if (res.status == 200) {
                        setCompletedRides(res.data.data);
                        setIsLoading(false);
                        setTotalAmount(res.data.totalAmount);
                        setCommissionAmount(res.data.totalCommission);
                    }
                }
            )
        } else {
            riderService.getAllCompletedRides().then(
                (res) => {
                    if (res.status == 200) {
                        setCompletedRides(res.data.data);
                        setTotalAmount(res.data.totalAmount);
                        setCommissionAmount(res.data.totalCommission);
                    }
                }
            )
        }

    }, [riderName, createdDate])
    const handleRiderNameChange = (e) => setRiderName(e.target.value);
    const handleCreatedDateChange = (e) => setCreatedDate(e.target.value);

    const getAllRiders = () => {
        riderService.getAllRiderName().then(
            (res) => {
                if (res.status == 200) {
                    setAllRiders(res.data.riders);
                }
            }
        )
    }

    return (
        <>
            <div>

                <div className="w-9/12 mx-auto">
                    <div>
                        <div>
                            <h1 className="text-3xl font-bold my-5 text-purple-400 text-center">
                                All Completed ride
                            </h1>
                        </div>
                        <div className="mb-4">
                            <label className="block text-lg font-medium mb-1">Rider Name</label>
                            <select
                                value={riderName}
                                onChange={handleRiderNameChange}
                                className="border border-gray-300 p-2 rounded w-full"
                            >
                                <option value="">Select a Rider</option>
                                {allRiders.map((rider, index) => (
                                    <option key={index} value={rider.full_name}>
                                        {rider.full_name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="mb-4">
                            <label className="block text-lg font-medium mb-1">Created Date</label>
                            <input
                                type="date"
                                value={createdDate}
                                onChange={handleCreatedDateChange}
                                className="border border-gray-300 p-2 rounded w-full"
                            />
                        </div>

                        <>
                            <div className="overflow-x-auto">
                                <table className="table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>S.N</th>
                                            <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Rider Name</th>
                                            <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Starting Point</th>
                                            <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Destination</th>
                                            <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Distance</th>
                                            <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Price</th>
                                            <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Owner Commission</th>
                                            <th style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Created Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {completedRides?.map((ride, index) => (

                                            <tr key={index}>

                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{index + 1}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.rider_name}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.starting_point}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.destination}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{ride.distance}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Rs:{ride.price}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>Rs:{ride.owner_commission}</td>
                                                <td style={{ border: '1px solid #dddddd', textAlign: 'left', padding: '8px' }}>{format(new Date(ride.created_at), 'dd/MM/yyyy')}</td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    </div>
                </div>


            </div>
            <center>
                <div class="amount-container">
                    <div class="amount">
                        <span class="label">Total:</span>
                        <span class="value" id="totalAmount">{totalAmount}</span>
                    </div>
                    <div class="amount">
                        <span class="label">Commission Amount:</span>
                        <span class="value" id="commissionAmount"> {commissionAmount}</span>
                    </div>
                </div>
            </center>

        </>
    );
}
